import React, { useState, useEffect } from "react";
import axios from "axios";
import CountUp from "react-countup";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { ENDPOINTS } from "../Helper/endpoints";
import Footer from "./Footer";

const Dashboard = ({ setCurrentPage }) => {
  const [countData, setCountData] = useState({
    invoices_count: 0, total_amount: 0, total_vendors: 0, total_users: 0,
    paid_amount: 0, unpaid_amount: 0,
  });

  const [recentInvoice, setRecentInvoice] = useState(null);
  const [pid, setPid] = useState(null);

  const getCookie = (cookieName) => {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === cookieName) return decodeURIComponent(value);
    }
    return null;
  };

  useEffect(() => {
    const fetchPid = () => {
      const userSessionData = getCookie("userSession");
      if (userSessionData) {
        try {
          const parsedSessionData = JSON.parse(userSessionData);
          setPid(parsedSessionData.data.user_info.organizations_pid);
        } catch (e) {
          console.error("Error parsing organizations_pid from cookie:", e); } } };
    fetchPid(); }, []);

  useEffect(() => {
    if (pid) {
      axios.get(ENDPOINTS.COUNT_DATA, { params: { organizations_pid: pid } })
        .then((response) => {
          setCountData(response.data?.data || {}); })
        .catch((error) => {
          console.error("Error fetching count data:", error);
          setCountData({}); }); }
  }, [pid]);

  useEffect(() => {
    const getOrganizationsPid = () => {
      const userSessionData = getCookie("userSession");
      if (userSessionData) {
        try {
          const parsedSessionData = JSON.parse(userSessionData);
          return parsedSessionData.data.user_info.organizations_pid;
        } catch (e) {
          console.error("Error parsing organizations_pid from cookie:", e);
          return null; } }
      return null; };

    const pid = getOrganizationsPid();
    axios.get(ENDPOINTS.INVOICES_INFO, { params: { organizations_pid: pid } })
      .then((response) => {
        console.log("Invoice response:", response.data);
        if (response.data.data.length > 0) {
          setRecentInvoice(response.data.data[0]); } })
      .catch((error) => {
        console.error("Error fetching invoice data:", error); }); }, [pid]);

  const pieData = [
    { name: "Unpaid Amount", value: countData?.unpaid_amount || 0 },
    { name: "Paid Amount", value: countData?.paid_amount || 0 },];

  const COLORS = ["#EC6613", "#1399EC"];

  return (
    <>
      <div className="dashboard">
        <div className="card-1">
          <span>Total Payment<br></br>Recommendation</span>
          <span className="count-value">
            <CountUp end={countData.invoices_count} duration={2} separator="," />
          </span>
        </div>
        <div className="card-2">
          <span>Total Vendor</span>
          <span className="count-value">
            <CountUp end={countData.total_vendors} duration={2} separator="," />
          </span>
        </div>
        <div className="card-3">
          <span>Total Users In<br></br>Organization</span>
          <span className="count-value">
            <CountUp end={countData.total_users} duration={2} separator="," />
          </span>
        </div>
        <div className="card-4">
          <span>Payment Recommendation<br></br>Amount</span>
          <span className="count-value">
            ₹<CountUp end={countData.total_amount} duration={2} separator="," />
          </span>
        </div>
        <div className="card-5">
          <span>Paid Payment<br></br>Recommendation</span>
          <span className="count-value">
            ₹<CountUp end={countData.paid_amount} duration={2} separator="," />
          </span>
        </div>
        <div className="card-6">
          <span>Unpaid Payment<br></br>Recommendation</span>
          <span className="count-value">
            ₹<CountUp end={countData.unpaid_amount} duration={2} separator="," />
          </span>
        </div>
      </div>

      <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap", backgroundColor: "#f2edf3", marginBottom: "60px" }}>
        {/* Recent Invoice Card */}
        <div className="recent-invoice-container" style={{
          flex: "1", minWidth: "300px", borderRadius: "8px",
          overflow: "hidden", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", backgroundColor: "#fff", marginLeft: "62px", }}>

          <div style={{
            backgroundColor: "#191056", padding: "10px", fontWeight: "bold", fontSize: "18px",
            textAlign: "center", color: "#fff" }}> Latest Created Payment Recommendation
          </div>

          <div style={{ padding: "16px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px" }}>
            {recentInvoice ? (<>
              <span><strong>Vendor:</strong> {recentInvoice.name}</span>
              <span><strong>Amount:</strong> ₹<CountUp end={recentInvoice.net_payable} duration={2} separator="," /></span>
              <span><strong>PR No:</strong> {recentInvoice.pr_no}</span>
              <span><strong>PR Date:</strong> {new Date(recentInvoice.pr_date).toLocaleDateString('en-GB')}</span>
              <span><strong>Invoice No:</strong> {recentInvoice.invoice_no}</span>
              <span><strong>Invoice Date:</strong> {new Date(recentInvoice.invoice_date).toLocaleDateString('en-GB')}</span>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "72%", gridColumn: "span 2" }}>
                <span style={{ fontSize: "16px", fontWeight: "bold" }}>Status: <span style={{ fontWeight: "normal" }}>{recentInvoice.status}</span></span>
                <button onClick={() => setCurrentPage('PRList')}
                  style={{
                    color: "white", border: "1px solid black", padding: "6px 12px", borderRadius: "4px",
                    cursor: "pointer", backgroundColor: "rgb(25, 16, 86)", fontSize: "14px", fontWeight: "bold"
                  }} >
                  Show More </button>
              </div>
            </>
            ) : (
              <p>No recent invoices</p>
            )}
          </div>
        </div>
        {/* Pie Chart Card */}
        <div className="recent-invoice-container" style={{
          flex: "1", minWidth: "300px", borderRadius: "8px", overflow: "hidden",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)", backgroundColor: "#fff",
          marginRight: "62px", }}>
          <div style={{ backgroundColor: "#191056", padding: "10px", fontWeight: "bold",
            fontSize: "18px", textAlign: "center", color: "#fff" }}>
              Paid & Unpaid Payment </div>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie data={pieData} cx="50%" cy="50%"
                labelLine={false} outerRadius={100}
                dataKey="value" label={({ percent }) =>
                  ` ${(percent * 100).toFixed(0)}%` } >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index]} /> ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Dashboard;